import { useState } from "react"

export default function FormLinkBanner({ link }: { link: string }) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(link)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = link
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch { /* noop */ }
      document.body.removeChild(ta)
    }
    setCopied(true)
    window.setTimeout(() => setCopied(false), 1800)
  }

  return (
    <div
      className="rounded-2xl p-4 sm:p-5 mb-6"
      style={{ background: "rgba(200,146,58,0.1)", border: "1px solid rgba(200,146,58,0.35)" }}
    >
      <p className="text-[10px] tracking-[0.3em] uppercase font-body mb-2" style={{ color: "#E0B870" }}>
        Link para envio à cliente
      </p>
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 text-[14px] sm:text-[15px] font-body break-all hover:underline"
          style={{ color: "#E0B870" }}
        >
          {link}
        </a>
        <button
          onClick={handleCopy}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-[11px] font-body tracking-[0.1em] uppercase transition-all duration-150 active:scale-[0.97]"
          style={{
            color: copied ? "#22c55e" : "#E0B870",
            background: copied ? "rgba(34,197,94,0.12)" : "rgba(200,146,58,0.18)",
            border: `1px solid ${copied ? "rgba(34,197,94,0.35)" : "rgba(200,146,58,0.35)"}`,
          }}
        >
          {copied ? "Copiado" : "Copiar link"}
        </button>
      </div>
    </div>
  )
}
